"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Explanation_1 = __importDefault(require("../Explanation"));
const common_1 = require("./common");
const styled_components_1 = __importDefault(require("styled-components"));
function Operation({ nodeValue, explanation, operator, unit }) {
    const isUnaryOperation = explanation[0].nodeValue === 0 &&
        operator === '−' &&
        explanation[0].nodeKind === 'constant';
    return (jsx_runtime_1.jsxs(StyledOperation, Object.assign({ className: "operation" }, { children: [!isUnaryOperation && jsx_runtime_1.jsx(Explanation_1.default, { node: explanation[0] }, void 0), " ", operator, ' ', jsx_runtime_1.jsx(Explanation_1.default, { node: explanation[1] }, void 0), nodeValue != null && (jsx_runtime_1.jsxs("span", Object.assign({ className: "result" }, { children: [jsx_runtime_1.jsx("small", { children: " =\u00A0" }, void 0), jsx_runtime_1.jsx(common_1.NodeValuePointer, { data: nodeValue, unit: unit }, void 0)] }), void 0))] }), void 0));
}
exports.default = Operation;
const StyledOperation = styled_components_1.default.span `
	::before {
		content: '(';
	}
	> .operation ::before,
	> .operation ::after {
		content: '';
	}
	::after {
		content: ')';
	}
	.result {
		margin-left: 0.2rem;
	}
	.operation .result {
		display: none;
	}
`;
